import { Box, Button } from "@mui/material";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { TbQrcode } from "react-icons/tb";

import CommonGridTable from "@/components/CommonGridTable";
import { ElitSheet } from "@/layout/ElitSheet/ElitSheet";

import { useVehiclesContext } from "../VehiclesContext";
import { PrintVehicleIds } from "../components/PrintVehicleIds";
import { QRCodeDialog } from "../components/QRCodeDialog";

function CustomToolbar() {
    const { t } = useTranslation();
    const { setShowPrintPage } = useVehiclesContext();
    return (
        <GridToolbarContainer>
            <Box sx={{ flexGrow: 1 }} />
            <Button
                variant="outlined"
                color="primary"
                className="!my-1"
                startIcon={<TbQrcode />}
                sx={{ paddingX: 2, textTransform: "capitalize" }}
                onClick={() => {
                    setShowPrintPage(true);
                }}
            >
                {t("printBarcodes")}
            </Button>
        </GridToolbarContainer>
    );
}

export const VehicleTable = () => {
    const { api, columns, fullScreen, rows, loading, qrCodeVehicle, setQrCodeVehicle, showPrintPage } =
        useVehiclesContext();

    return (
        <>
            <div
                className={`${fullScreen ? "fixed inset-0 z-50 bg-white p-0 flex" : "grid grid-cols-12   gap-2 h-full "} table`}
            >
                <div className="col-span-12 flex w-full   overflow-auto  h-full  ">
                    <CommonGridTable
                        api={api}
                        rows={rows}
                        columns={columns}
                        loading={loading}
                        toolbar={CustomToolbar}
                    />
                </div>
            </div>
            <ElitSheet
                open={!!qrCodeVehicle}
                handleClose={() => {
                    setQrCodeVehicle(null);
                }}
            >
                <QRCodeDialog
                    plate={qrCodeVehicle?.plate || ""}
                    vehicleId={qrCodeVehicle?.vehicleId || ""}
                    driverId={qrCodeVehicle?.driverId || ""}
                />
            </ElitSheet>
            {showPrintPage && <PrintVehicleIds />}
        </>
    );
};
